import axios from "axios";
import { base_url } from "../../../utils/baseUrl";



const getBoards = async (token) => {
  
  const response = await axios.get(`${base_url}boards/getAllBoards`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
      Accept: "application/json",
    }
  });
 
  return response.data;
  
};
const createBoard = async (values) => {
  const token = values.get("token") 
  
  const response = await axios.post(
    `${base_url}boards/addBoards`,
    values, // Pass form data directly
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        Accept: "application/json",
      },
    }
  );

  return response.data;
};

const updateBoard = async (values) => {
  const id = values.get("id") 
  const response = await axios.put(
    `${base_url}boards/editBoards/${id}`,
    values,

  );

  return response.data;
};

const getBoard = async (id) => {
  const response = await axios.get(`${base_url}boards/getById/${id}`);

  return response.data;
};

const deleteBoard = async (id) => {
  const response = await axios.delete(`${base_url}boards/deleteBoards/${id}`);

  return response.data;
};
const BoardService = {
  getBoards,
  createBoard,
  getBoard,
  updateBoard,
  deleteBoard,
};

export default BoardService;
